import Icon_space_food_006 from './assets/foodImages/space-food_006.jpg'
import Icon_space_food_005 from './assets/foodImages/space-food_005.jpg'
import Icon_space_food_008 from './assets/foodImages/space-food_008.jpg'
import Icon_space_food_007 from './assets/foodImages/space-food_007.jpg'
import Icon_space_food_042 from './assets/foodImages/space-food_042.jpg'
import Icon_IMG_1384a from './assets/foodImages/IMG_1384a.jpg'
import Icon_IMG_1392a from './assets/foodImages/IMG_1392a.jpg'
import Icon_70861 from './assets/foodImages/70861.JPG'
import Icon_70731 from './assets/foodImages/70731.JPG'
import Icon_photo_032 from './assets/foodImages/photo_032.JPG'
import Icon_photo_033 from './assets/foodImages/photo_033.JPG'
import Icon_photo_014 from './assets/foodImages/photo_014.JPG'
import Icon_photo_024 from './assets/foodImages/photo_024.JPG'
import Icon_photo_034 from './assets/foodImages/photo_034.JPG'
import Icon_photo_001 from './assets/foodImages/photo_001.JPG'
import Icon_photo_002 from './assets/foodImages/photo_002.JPG'
import Icon_photo_036 from './assets/foodImages/photo_036.JPG'
import Icon_photo_009 from './assets/foodImages/photo_009.JPG'
import Icon_photo_013 from './assets/foodImages/photo_013.JPG'
import Icon_photo_003 from './assets/foodImages/photo_003.JPG'
import Icon_photo_004 from './assets/foodImages/photo_004.JPG'
import Icon_photo_023 from './assets/foodImages/photo_023.JPG'
import Icon_photo_020 from './assets/foodImages/photo_020.JPG'
import Icon_macherel_misosoup from './assets/foodImages/macherel_misosoup.jpg'
import Icon_sardine_tomatosauce from './assets/foodImages/sardine_tomatosauce.jpg'
import Icon_macherel_pike_teriyakisauce from './assets/foodImages/macherel_pike_teriyakisauce.jpg'
import Icon_photo_017 from './assets/foodImages/photo_017.JPG'
import Icon_photo_018 from './assets/foodImages/photo_018.JPG'
import Icon_photo_021 from './assets/foodImages/photo_021.JPG'
import Icon_photo_022 from './assets/foodImages/photo_022.JPG'
import Icon_photo_015 from './assets/foodImages/photo_015.JPG'
import Icon_photo_016 from './assets/foodImages/photo_016.JPG'
import Icon_photo_019 from './assets/foodImages/photo_019.JPG'
import Icon_photo_005 from './assets/foodImages/photo_005.JPG'
import Icon_photo_006 from './assets/foodImages/photo_006.JPG'
import Icon_photo_007 from './assets/foodImages/photo_007.JPG'
import Icon_photo_008 from './assets/foodImages/photo_008.JPG'
import Icon_mayonnaise from './assets/foodImages/mayonnaise.jpg'
import Icon_photo_035 from './assets/foodImages/photo_035.JPG'
import Icon_ramen_soysauce from './assets/foodImages/ramen_soysauce.jpg'
import Icon_ramen_seafood from './assets/foodImages/ramen_seafood.jpg'
import Icon_ramen_curry from './assets/foodImages/ramen_curry.jpg'
import Icon_images_photo_012 from './assets/foodImages/photo_012.JPG'
import Icon_photo_010 from './assets/foodImages/photo_010.JPG'
import Icon_photo_011 from './assets/foodImages/photo_011.JPG'

export const foodList = [
  {
    id: 1,
    imageUrl: Icon_space_food_006,
    name: "日清スペースチキンラーメン",
    description:  "お湯を注入して食べる",
    contents: "35.7g（1包当り）（麺6.3ｇ×3個）",
    nutorition: { calorie: 153, vidaminD: 20 },
    maker:  "日清食品ホールディングス株式会社",
    stocked: 20,
  },
  {
    id: 2,
    imageUrl: Icon_space_food_005,
    name: "スペース日清焼そばU.F.O.",
    description:  "お湯を注入して食べる",
    contents: "36.9g（1包当り）（麺4.7ｇ×5個）",
    nutorition: { calorie: 168, vidaminD: 20 },
    maker:  "日清食品ホールディングス株式会社",
    stocked: 20,
  },
  {
    id: 3,
    imageUrl: Icon_space_food_008,
    name: "日清スペースキーマカレーメシ",
    description:  "お湯を注入して食べる",
    contents: "74.8g（1包当り）",
    nutorition: { calorie: 331, vidaminD: 20 },
    maker:  "日清食品ホールディングス株式会社",
    stocked: 20,
  },
  {
    id: 4,
    imageUrl: Icon_space_food_007,
    name: "日清スペースハヤシメシ",
    description:  "お湯を注入して食べる",
    contents: "76.2g（1包当り）",
    nutorition: { calorie: 335, vidaminD: 20 },
    maker:  "日清食品ホールディングス株式会社",
    stocked: 20,
  },
  {
    id: 5,
    imageUrl: Icon_space_food_042,
    name: "イベリコ豚とマッシュルームのカレー（レトルトカレー宇宙食）",
    description:  "専用の加温器で温めて食べる",
    contents: "180g（1包当り）",
    nutorition: { calorie: 285, vidaminD: 20 },
    maker:  "ハウス食品株式会社",
    stocked: 20,
  },
  {
    id: 6,
    imageUrl: Icon_IMG_1384a,
    name: "スペースからあげクン",
    description:  "そのまま食べる",
    contents: "12g（1包あたり）",
    nutorition: { calorie: 66.6, vidaminD: 20 },
    maker:  "株式会社ローソン",
    stocked: 20,
  },
  {
    id: 7,
    imageUrl: Icon_IMG_1392a,
    name: "森永ミルク生活（宇宙用）",
    description:  "水を注入して飲む",
    contents: "20g（1包あたり）",
    nutorition: { calorie: 95, vidaminD: 20 },
    maker:  "森永乳業株式会社",
    stocked: 20,
  },
  {
    id: 8,
    imageUrl: Icon_70861,
    name: "スペースまるとっとアジ（燻製しお味）",
    description:  "そのまま食べる",
    contents: "50ｇ（1包あたり）",
    nutorition: { calorie: 95, vidaminD: 20 },
    maker:  "株式会社キシモト",
    stocked: 20,
  },
  {
    id: 9,
    imageUrl: Icon_70731,
    name: "ちりめん山椒",
    description:  "そのまま食べる",
    contents: "10ｇ（1包あたり）",
    nutorition: { calorie: 24, vidaminD: 20 },
    maker:  "宝食品株式会社",
    stocked: 20,
  },
  {
    id: 10,
    imageUrl: Icon_photo_032,
    name: "ホテイやきとり（たれ味）宇宙用",
    description:  "そのまま、または専用の加温器で温めて食べる",
    contents: "96～105g（1包当り）",
    nutorition: { calorie: 196, vidaminD: 20 },
    maker:  "株式会社ホテイフーズコーポレーション",
    stocked: 20,
  },
  {
    id: 11,
    imageUrl: Icon_photo_033,
    name: "ホテイやきとり（柚子こしょう味）宇宙用",
    description:  "そのまま、または専用の加温器で温めて食べる",
    contents: "91～100g（1包当り）",
    nutorition: { calorie: 136, vidaminD: 20 },
    maker:  "株式会社ホテイフーズコーポレーション",
    stocked: 20,
  },
  {
    id: 12,
    imageUrl: Icon_photo_014,
    name: "宇宙食 特濃ミルク8.2",
    description:  "そのまま食べる",
    contents: "21.8g（1包（5個入り）当り）",
    nutorition: { calorie: 92, vidaminD: 20 },
    maker:  "味覚糖株式会社",
    stocked: 20,
  },
  {
    id: 13,
    imageUrl: Icon_photo_024,
    name: "味付海苔",
    description:  "そのまま食べる",
    contents: "3.8g（2袋（1袋8切5枚入り）当たり）",
    nutorition: { calorie: 13.8, vidaminD: 20 },
    maker:  "株式会社山本海苔店",
    stocked: 20,
  },
  {
    id: 14,
    imageUrl: Icon_photo_034,
    name: "サバ醤油味付け缶詰",
    description:  "そのまま、または専用の加温器で温めて食べる",
    contents: "120±10g",
    nutorition: { calorie: 238, vidaminD: 20 },
    maker:  "福井県立若狭高等学校",
    stocked: 20,
  },
  {
    id: 15,
    imageUrl: Icon_photo_001,
    name: "SPACEビスコ",
    description:  "そのまま食べる",
    contents: "16.5g（2袋（各2枚入り）当たり）",
    nutorition: { calorie: 78, vidaminD: 20 },
    maker:  "江崎グリコ株式会社",
    stocked: 20,
  },
  {
    id: 16,
    imageUrl: Icon_photo_002,
    name: "切り餅",
    description:  "専用の加温器で温めて食べる",
    contents: "83～93g（1包（4個入り）当り）",
    nutorition: { calorie: 199, vidaminD: 20 },
    maker:  "越後製菓株式会社",
    stocked: 20,
  },
  {
    id: 17,
    imageUrl: Icon_photo_036,
    name: "キッコーマン宇宙生しょうゆ",
    description:  "つけて食べる",
    contents: "200ml",
    nutorition: { calorie: 14, vidaminD: 20 },
    maker:  "キッコーマン食品株式会社",
    stocked: 20,
  },
  {
    id: 18,
    imageUrl: Icon_photo_009,
    name: "亀田の柿の種（宇宙食）",
    description:  "そのまま食べる",
    contents: "35g（1包当り）",
    nutorition: { calorie: 168, vidaminD: 20 },
    maker:  "亀田製菓株式会社",
    stocked: 20,
  },
  {
    id: 19,
    imageUrl: Icon_photo_013,
    name: "ピーチゼリー",
    description:  "そのまま食べる",
    contents: "63g（1個当り）",
    nutorition: { calorie: 49, vidaminD: 20 },
    maker:  "ハウス食品株式会社",
    stocked: 20,
  },
  {
    id: 20,
    imageUrl: Icon_photo_003,
    name: "バランス栄養食ブロックタイプ（チーズ味）",
    description:  "そのまま食べる",
    contents: "40g（1包当り）",
    nutorition: { calorie: 200, vidaminD: 20 },
    maker:  "大塚製薬株式会社",
    stocked: 20,
  },
  {
    id: 21,
    imageUrl: Icon_photo_004,
    name: "イオンドリンク",
    description:  "水を注入して食べる",
    contents: "11.1g（1包当り）",
    nutorition: { calorie: 43.2, vidaminD: 20 },
    maker:  "大塚製薬株式会社",
    stocked: 20,
  },
  {
    id: 22,
    imageUrl: Icon_photo_023,
    name: "プルーンエキストラクト",
    description:  "そのまま食べる",
    contents: "60g（1包（2本入り）当たり）",
    nutorition: { calorie: 165.6, vidaminD: 20 },
    maker:  "三基商事株式会社",
    stocked: 20,
  },
  {
    id: 23,
    imageUrl: Icon_photo_020,
    name: "キシリトールガム（ライムミント）",
    description:  "そのまま食べる",
    contents: "21g（1包（14粒入り）当たり）",
    nutorition: { calorie: 42, vidaminD: 20 },
    maker:  "株式会社ロッテ",
    stocked: 20,
  },
  {
    id: 24,
    imageUrl: Icon_macherel_misosoup,
    name: "サバの味噌煮",
    description:  "そのまま、または専用の加温器で温めて食べる",
    contents: "110g（1包当り）",
    nutorition: { calorie: 325, vidaminD: 20 },
    maker:  "マルハニチロ株式会社",
    stocked: 20,
  },
  {
    id: 25,
    imageUrl: Icon_sardine_tomatosauce,
    name: "イワシのトマト煮",
    description:  "そのまま、または専用の加温器で温めて食べる",
    contents: "100g（1包当り）",
    nutorition: { calorie: 185, vidaminD: 20 },
    maker:  "マルハニチロ株式会社",
    stocked: 20,
  },
  {
    id: 26,
    imageUrl: Icon_macherel_pike_teriyakisauce,
    name: "サンマの蒲焼き",
    description:  "そのまま、または専用の加温器で温めて食べる",
    contents: "100g（1包当り）",
    nutorition: { calorie: 283, vidaminD: 20 },
    maker:  "マルハニチロ株式会社",
    stocked: 20,
  },
  {
    id: 27,
    imageUrl: Icon_photo_017,
    name: "粉末緑茶",
    description:  "お湯を注入して飲む",
    contents: "1.2g（1包当り）",
    nutorition: { calorie: 4, vidaminD: 20 },
    maker:  "三井農林株式会社",
    stocked: 20,
  },
  {
    id: 28,
    imageUrl: Icon_photo_018,
    name: "粉末ウーロン茶",
    description:  "お湯を注入して飲む",
    contents: "2.0g（1包当り）",
    nutorition: { calorie: 7, vidaminD: 20 },
    maker:  "三井農林株式会社",
    stocked: 20,
  },
  {
    id: 29,
    imageUrl: Icon_photo_021,
    name: "羊羹（小倉）",
    description:  "そのまま食べる",
    contents: "62g（1包当り）",
    nutorition: { calorie: 173, vidaminD: 20 },
    maker:  "山崎製パン株式会社",
    stocked: 20,
  },
  {
    id: 30,
    imageUrl: Icon_photo_022,
    name: "羊羹（栗）",
    description:  "そのまま食べる",
    contents: "62g（1包当り）",
    nutorition: { calorie: 175, vidaminD: 20 },
    maker:  "山崎製パン株式会社",
    stocked: 20,
  },
  {
    id: 31,
    imageUrl: Icon_photo_015,
    name: "黒飴",
    description:  "そのまま食べる",
    contents: "26.5g（1包（5個入り）当り）",
    nutorition: { calorie: 102, vidaminD: 20 },
    maker:  "ヤマザキビスケット株式会社",
    stocked: 20,
  },
  {
    id: 32,
    imageUrl: Icon_photo_016,
    name: "ミントキャンディー",
    description:  "そのまま食べる",
    contents: "20.5g（1包（5個入り）当り）",
    nutorition: { calorie: 79, vidaminD: 20 },
    maker:  "ヤマザキビスケット株式会社",
    stocked: 20,
  },
  {
    id: 33,
    imageUrl: Icon_photo_019,
    name: "わかめスープ",
    description:  "お湯を注入して食べる",
    contents: "6.4g（1包当り）",
    nutorition: { calorie: 19, vidaminD: 20 },
    maker:  "理研ビタミン株式会社",
    stocked: 20,
  },
  {
    id: 34,
    imageUrl: Icon_photo_005,
    name: "白飯",
    description:  "お湯を注入して食べる",
    contents: "62g（1包当り）（出来上り量：162g）",
    nutorition: { calorie: 228, vidaminD: 20 },
    maker:  "尾西食品株式会社",
    stocked: 20,
  },
  {
    id: 35,
    imageUrl: Icon_photo_006,
    name: "赤飯",
    description:  "お湯を注入して食べる",
    contents: "68g（1包当り） （出来上り量：143g）",
    nutorition: { calorie: 249, vidaminD: 20 },
    maker:  "尾西食品株式会社",
    stocked: 20,
  },
  {
    id: 36,
    imageUrl: Icon_photo_007,
    name: "山菜おこわ",
    description:  "お湯を注入して食べる",
    contents: "68g（1包当り）（出来上り量：168g）",
    nutorition: { calorie: 245, vidaminD: 20 },
    maker:  "尾西食品株式会社",
    stocked: 20,
  },
  {
    id: 37,
    imageUrl: Icon_photo_008,
    name: "おにぎり 鮭",
    description:  "お湯を注入して食べる",
    contents: "50g（1包当り）（出来上り量：125g）",
    nutorition: { calorie: 188, vidaminD: 20 },
    maker:  "尾西食品株式会社",
    stocked: 20,
  },
  {
    id: 38,
    imageUrl: Icon_mayonnaise,
    name: "マヨネーズ",
    description:  "そのまま食品にかける",
    contents: "50g（1包当り）",
    nutorition: { calorie: 350, vidaminD: 20 },
    maker:  "キユーピー株式会社",
    stocked: 20,
  },
  {
    id: 39,
    imageUrl: Icon_photo_035,
    name: "白がゆ",
    description:  "専用の加温器で温めて食べる",
    contents: "250g（1包当り）",
    nutorition: { calorie: 113, vidaminD: 20 },
    maker:  "キユーピー株式会社",
    stocked: 20,
  },
  {
    id: 40,
    imageUrl: Icon_ramen_soysauce,
    name: "日清スペースカップヌードル",
    description:  "お湯を注入して食べる",
    contents: "約35.6g（1包当り）（麺6.3g×3個）",
    nutorition: { calorie: 160, vidaminD: 20 },
    maker:  "日清食品ホールディングス株式会社",
    stocked: 20,
  },
  {
    id: 41,
    imageUrl: Icon_ramen_seafood,
    name: "日清スペースシーフードヌードル",
    description:  "お湯を注入して食べる",
    contents: "約34.9g（1包当り） （麺6.3g×3個）",
    nutorition: { calorie: 147, vidaminD: 20 },
    maker:  "日清食品ホールディングス株式会社",
    stocked: 20,
  },
  {
    id: 42,
    imageUrl: Icon_ramen_curry,
    name: "日清スペースカップヌードルカレー",
    description:  "お湯を注入して食べる",
    contents: "約45.6g（1包当り）（麺6.3g×3個）",
    nutorition: { calorie: 227, vidaminD: 20 },
    maker:  "日清食品ホールディングス株式会社",
    stocked: 20,
  },
  {
    id: 43,
    imageUrl: Icon_images_photo_012,
    name: "レトルト チキンカレー",
    description:  "専用の加温器で温めて食べる",
    contents: "140g（1包当り）",
    nutorition: { calorie: 125, vidaminD: 20 },
    maker:  "ハウス食品株式会社",
    stocked: 20,
  },
  {
    id: 44,
    imageUrl: Icon_photo_010,
    name: "レトルト ビーフカレー",
    description:  "専用の加温器で温めて食べる",
    contents: "140g（1包当り）",
    nutorition: { calorie: 130, vidaminD: 20 },
    maker:  "ハウス食品株式会社",
    stocked: 20,
  },
  {
    id: 45,
    imageUrl: Icon_photo_011,
    name: "レトルト ポークカレー",
    description:  "専用の加温器で温めて食べる",
    contents: "140g（1包当り）",
    nutorition: { calorie: 144, vidaminD: 20 },
    maker:  "ハウス食品株式会社",
    stocked: 20,
  }
];
